import { ChatChannelType, IChatConversation } from 'src/@types/chat';
import Iconify from 'src/components/iconify';

const iconType: Record<ChatChannelType, string> = {
  [ChatChannelType.MEET]: 'ph:video-camera',
  [ChatChannelType.TEXT]: 'tabler:hash',
  [ChatChannelType.VOICE]: 'tabler:volume',
};

export const ChannelAvatar = ({
  channel,
}: {
  channel: Pick<IChatConversation, 'name' | 'picture' | 'type' | 'icon'>;
}) => {
  if (!channel.icon) return <Iconify icon={iconType[channel.type]} />;

  return <em-emoji shortcodes={channel.icon} />;
};
